// Libraries
import { Box } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import { SeamsilProductsStyle } from "./SeamsilProductsStyle";

import { isNullOrUndefined } from "Custom/Utils/Utils";

import { Delglaze } from "./Delglaze";
import { Seamsil100 } from "./SeamsilSubViews/Seamsil100";

import { DelglazeViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/DelglazeViewModel";
import { SeamsilProductsViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/SeamsilProductsViewModel";
import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/ProductsCommonViewModel";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    delglazeViewModel: DelglazeViewModel;
    viewModel: SeamsilProductsViewModel;
}

export const SeamsilProducts: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const seamsilProductsStyle = SeamsilProductsStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={seamsilProductsStyle.root}>
            {props.viewModel.canDisplaySubstrateUndefined && (
                <Seamsil100 commonViewModel={props.commonViewModel} delglazeViewModel={props.delglazeViewModel} viewModel={props.viewModel.Seamsil100ViewModel} />
            )}
        </Box>
    ));

    // #endregion Render Result
};
